import type { Tabs } from 'expo-router';
import { NativeStackNavigationOptions } from 'expo-router/native-stack';
import type { ComponentProps } from 'react';

import { BASE_COLORS } from './colors';

/**
 * expo-router vendors react-navigation from SDK 56 and exposes no public path for the
 * bottom-tab option types, so they are read off the `Tabs` layout's own props.
 */
type BottomTabNavigationOptions = Exclude<
  NonNullable<ComponentProps<typeof Tabs>['screenOptions']>,
  (...args: never[]) => unknown
>;

export const BASE_SCREEN_OPTIONS: Partial<
  NativeStackNavigationOptions & BottomTabNavigationOptions
> = {
  headerShadowVisible: false,
  headerShown: false, // ← must declare the Header where needed
};

// NOTE use BASE_STACK_SCREEN_OPTIONS with Stack.Screen options only ( not Tabs / Tabs.Screen )
export const BASE_STACK_SCREEN_OPTIONS: NativeStackNavigationOptions = {
  ...BASE_SCREEN_OPTIONS,
  navigationBarHidden: true, // ← forces navigation with Header on Android
  statusBarBackgroundColor: BASE_COLORS.transparent,
} as const;
